<template>
    <div class="row">
        <form-input
            v-model="item.name"
            label="Name"
            :error-message="getError('name')"
            placeholder="Name"
            @blur="$emit('on-name-change', item.name)"
        />
    </div>
</template>

<script>
import BaseForm from '@/components/elements/BaseForm';

export default {
    extends: BaseForm
};
</script>
